/**
 * JHYM 首屏 banner —— 移动端换用专用图
 *
 * 为什么需要：
 *   桌面横幅图是 3136×1306（2.40:1），而移动端显示框是 3:2
 *   （见 jhym-custom.css 第 9 节）。比例差会让 cover 横向裁掉大半，
 *   手机上只剩原图中间一条。
 *
 *   但 Shopify 的 image-banner 板块**没有** mobile 图片字段，
 *   所以只能在运行时把图源换掉。
 *
 * 专用图：jhym-banner-mobile.jpg（1176×784，精确 3:2，零裁切）
 *
 * ⚠️ 必须支持「双向切换」：
 *   只换不还原的话，在窄屏换过图之后再拉宽窗口（或 DevTools 切回桌面），
 *   桌面会继续显示那张小图。所以这里用 data 属性记住原始 src/srcset，
 *   宽屏时还原。
 */
(function () {
  var MQ = '(max-width: 749px)';
  var MOBILE_SRC =
    'https://cdn.shopify.com/s/files/1/0768/9735/3902/files/jhym-banner-mobile.jpg';
  var ATTR_SRC = 'data-jhym-orig-src';
  var ATTR_SRCSET = 'data-jhym-orig-srcset';
  var ATTR_W = 'data-jhym-orig-width';
  var ATTR_H = 'data-jhym-orig-height';
  var ATTR_ON = 'data-jhym-mobile-banner';

  function apply() {
    var sec = document.querySelector("[id*='__slide_banner']");
    if (!sec) return;

    var isMobile = window.matchMedia(MQ).matches;
    var imgs = sec.querySelectorAll('picture img, img');

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var cur = img.getAttribute('src') || '';
      var isSwapped = img.getAttribute(ATTR_ON) === '1';

      // 只处理 banner 主图；换过的也要继续处理，以便宽屏时还原
      if (!isSwapped && cur.indexOf('/banner') === -1) continue;

      if (isMobile) {
        if (isSwapped) continue;
        img.setAttribute(ATTR_SRC, cur);
        var ss = img.getAttribute('srcset');
        if (ss) img.setAttribute(ATTR_SRCSET, ss);
        img.setAttribute(ATTR_W, img.getAttribute('width') || '');
        img.setAttribute(ATTR_H, img.getAttribute('height') || '');

        // 必须先摘掉 srcset，否则浏览器会从原图的候选里挑，
        // 换了 src 也没用
        img.removeAttribute('srcset');
        img.setAttribute('src', MOBILE_SRC);
        img.setAttribute('width', '1176');
        img.setAttribute('height', '784');
        img.setAttribute(ATTR_ON, '1');
      } else if (isSwapped) {
        var orig = img.getAttribute(ATTR_SRC);
        var origSet = img.getAttribute(ATTR_SRCSET);
        if (orig) img.setAttribute('src', orig);
        if (origSet) img.setAttribute('srcset', origSet);
        var w = img.getAttribute(ATTR_W);
        var h = img.getAttribute(ATTR_H);
        if (w) img.setAttribute('width', w);
        if (h) img.setAttribute('height', h);
        img.removeAttribute(ATTR_ON);
      }
    }
  }

  // 图片可能是懒加载后才出现的，另外新建图片元素也不会触发 load，
  // 故按时间点重试几次。
  [0, 300, 900, 1800, 3000].forEach(function (ms) {
    setTimeout(apply, ms);
  });
  window.addEventListener('load', function () {
    setTimeout(apply, 300);
  });
  window.addEventListener('resize', function () {
    setTimeout(apply, 300);
  });
})();
